var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgKickerCards = function SvgKickerCards(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9.5,
    y: 6.5,
    width: 12,
    height: 18,
    rx: 1,
    fill: "#05A1C9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 6.5,
    y: 3.5,
    width: 12,
    height: 18,
    rx: 1,
    fill: "#D80C9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 3.5,
    y: 0.5,
    width: 12,
    height: 18,
    rx: 1,
    fill: "#3D50FC"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKickerCards);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iOS41IiB5PSI2LjUiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxOCIgcng9IjEiIGZpbGw9IiMwNUExQzkiLz4KPHJlY3Qgb3BhY2l0eT0iMC42IiB4PSI2LjUiIHk9IjMuNSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjE4IiByeD0iMSIgZmlsbD0iI0Q4MEM5QSIvPgo8cmVjdCBvcGFjaXR5PSIwLjYiIHg9IjMuNSIgeT0iMC41IiB3aWR0aD0iMTIiIGhlaWdodD0iMTgiIHJ4PSIxIiBmaWxsPSIjM0Q1MEZDIi8+Cjwvc3ZnPgo=";